// Blueprint: forge/blueprint/frontend/architecture/001-shell-composition.md
import { useEffect } from 'react';
import { useDependencies } from '@servicetitan/react-ioc';
import { usePrefetch } from '@servicetitan/web-components';

import { AppStore } from '../stores/app.store';

/**
 * Warm every enabled route-module bundle after the registry is ready, matching
 * Enterprise Hub's `usePrefetchRouteModules`. The Shell only mounts one
 * `<Loader>` at a time; this prefetch means later nav is a cache hit.
 */
export function usePrefetchRouteModules() {
    const [{ routeModules }] = useDependencies(AppStore);
    const { prefetch } = usePrefetch();

    useEffect(() => {
        routeModules.forEach(module => {
            prefetch(module.mfeUrl);
        });
    }, [routeModules, prefetch]);
}
